/**
 * AI 报告 markdown 渲染前规范化。
 * 修复 CommonMark 强调规则导致的加粗失效：
 * 1. 闭合 `**` 前是标点时（如 `）**汉` 的 `）`），若 `**` 后紧贴汉字，
 *    `**` 不能作为强调闭合分隔符 → 在闭合 `**` 后补空格。
 * 2. 开启 `**` 前是汉字、后是标点时（如 `文**（` 的 `（`），`**` 不是
 *    left-flanking，不能作为强调开启分隔符 → 在开启 `**` 前补空格。
 */
const CJK_PUNCT_RE = /[」』"『「“”‘’！？，、。；：·—…（）()\[\]{}]/;
const HAN_RE = /[\u4e00-\u9fff]/;

export function normalizeMarkdownForRender(markdown: string): string {
  let result = '';
  let inStrong = false;
  let i = 0;
  while (i < markdown.length) {
    const idx = markdown.indexOf('**', i);
    if (idx === -1) {
      result += markdown.slice(i);
      break;
    }
    result += markdown.slice(i, idx);
    const before = idx > 0 ? markdown[idx - 1] : '';
    const after = markdown[idx + 2];
    if (inStrong) {
      // 闭合 **：前是标点且后紧贴汉字时，补后空格使其能闭合
      const isClosingWithPunct = CJK_PUNCT_RE.test(before);
      const followedByHan = HAN_RE.test(after ?? '');
      if (isClosingWithPunct && followedByHan) {
        result += '** ';
      } else {
        result += '**';
      }
      inStrong = false;
    } else {
      // 开启 **：前是汉字且后是标点时，补前空格使其能开启（left-flanking）
      const prevIsHan = HAN_RE.test(before);
      const nextIsPunct = CJK_PUNCT_RE.test(after ?? '');
      if (prevIsHan && nextIsPunct) {
        result += ' **';
      } else {
        result += '**';
      }
      inStrong = true;
    }
    i = idx + 2;
  }
  return result;
}
